{
  "$schema": "https://mux.run/theme.json",
  "name": "Lucent Orng",
  "id": "lucent-orng",
  "light": {
    "palette": {
      "neutral": "#fff5f0",
      "ink": "#1a1a1a",
      "primary": "#EC5B2B",
      "accent": "#c94d24",
      "success": "#0062d1",
      "warning": "#EC5B2B",
      "error": "#d1383d",
      "info": "#318795",
      "diffDelete": "#f52a65"
    },
    "overrides": {
      "text-weak": "#8a8a8a",
      "syntax-comment": "#8a8a8a",
      "syntax-keyword": "#EC5B2B",
      "syntax-string": "#0062d1",
      "syntax-primitive": "#c94d24",
      "syntax-variable": "#d1383d",
      "syntax-property": "#318795",
      "syntax-type": "#b0851f",
      "syntax-constant": "#EC5B2B",
      "syntax-operator": "#318795",
      "syntax-punctuation": "#1a1a1a",
      "syntax-object": "#d1383d",
      "markdown-heading": "#EC5B2B",
      "markdown-text": "#1a1a1a",
      "markdown-link": "#EC5B2B",
      "markdown-link-text": "#318795",
      "markdown-code": "#0062d1",
      "markdown-block-quote": "#b0851f",
      "markdown-emph": "#b0851f",
      "markdown-strong": "#EC5B2B",
      "markdown-horizontal-rule": "#8a8a8a",
      "markdown-list-item": "#EC5B2B",
      "markdown-list-enumeration": "#318795",
      "markdown-image": "#EC5B2B",
      "markdown-image-text": "#318795",
      "markdown-code-block": "#1a1a1a"
    }
  },
  "dark": {
    "palette": {
      "neutral": "#2a1a15",
      "ink": "#eeeeee",
      "primary": "#EC5B2B",
      "accent": "#FFF7F1",
      "success": "#6ba1e6",
      "warning": "#EC5B2B",
      "error": "#e06c75",
      "info": "#56b6c2",
      "diffDelete": "#e26a75"
    },
    "overrides": {
      "text-weak": "#808080",
      "syntax-comment": "#808080",
      "syntax-keyword": "#EC5B2B",
      "syntax-string": "#6ba1e6",
      "syntax-primitive": "#EE7948",
      "syntax-variable": "#e06c75",
      "syntax-property": "#56b6c2",
      "syntax-type": "#e5c07b",
      "syntax-constant": "#FFF7F1",
      "syntax-operator": "#56b6c2",
      "syntax-punctuation": "#eeeeee",
      "syntax-object": "#e06c75",
      "markdown-heading": "#EC5B2B",
      "markdown-text": "#eeeeee",
      "markdown-link": "#EC5B2B",
      "markdown-link-text": "#56b6c2",
      "markdown-code": "#6ba1e6",
      "markdown-block-quote": "#FFF7F1",
      "markdown-emph": "#e5c07b",
      "markdown-strong": "#EE7948",
      "markdown-horizontal-rule": "#808080",
      "markdown-list-item": "#EC5B2B",
      "markdown-list-enumeration": "#56b6c2",
      "markdown-image": "#EC5B2B",
      "markdown-image-text": "#56b6c2",
      "markdown-code-block": "#eeeeee"
    }
  }
}
